import React from 'react'
import './style/Skill.css'

function Skill({ title, per }) {
    return (
        <div className="skill">
            <div className="skill__info">
                <p>{title}</p>
                <p>{per}%</p>
            </div>
            <div className="skill__bar">
                <span style={{width : `${per}%`}}></span>
            </div>
        </div>
    )
}

export default Skill
